export default __webpack_public_path__ + "static/travel-feature-cards-28424b09c4a7345f54fe6be148cbd143.gif";